/* Small presentation enhancement for the theme copy.
 * Review text stays intact; this only adds an accessible expand/collapse
 * affordance when a rendered card really overflows four mobile lines. */
(function () {
  'use strict';

  function enhance(root) {
    var cards = root.querySelectorAll('.imr-card');
    cards.forEach(function (card) {
      var body = card.querySelector('.imr-card__body');
      if (!body || !body.textContent.trim() || body.dataset.imrCompactReady) return;
      body.dataset.imrCompactReady = 'true';

      function refresh() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          body.classList.remove('is-imr-clamped');
          var old = card.querySelector('.imr-read-more');
          if (old) old.remove();
          return;
        }
        body.classList.add('is-imr-clamped');
        if (body.scrollHeight <= body.clientHeight + 2) {
          body.classList.remove('is-imr-clamped');
          return;
        }
        var control = document.createElement('button');
        control.type = 'button';
        control.className = 'imr-read-more';
        control.textContent = 'Leggi altro';
        control.setAttribute('aria-expanded', 'false');
        control.addEventListener('click', function () {
          var closed = body.classList.toggle('is-imr-clamped');
          control.textContent = closed ? 'Leggi altro' : 'Mostra meno';
          control.setAttribute('aria-expanded', closed ? 'false' : 'true');
        });
        body.insertAdjacentElement('afterend', control);
      }
      requestAnimationFrame(refresh);
    });
  }

  function observe(widget) {
    enhance(widget);
    new MutationObserver(function () { enhance(widget); }).observe(widget, { childList: true, subtree: true });
  }

  function start() {
    document.querySelectorAll('immershop-reviews').forEach(observe);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
